export type TrailingMonthsOption = 1 | 2 | 3;

export const DEFAULT_TRAILING_MONTHS: TrailingMonthsOption = 3;

// Full current month plus (trailingMonths - 1) prior months, through the 7th of the following month.
export const getTrailingDateRange = (
  trailingMonths: TrailingMonthsOption = DEFAULT_TRAILING_MONTHS
): { fromDate: Date; toDate: Date } => {
  const now = new Date();
  return {
    fromDate: new Date(now.getFullYear(), now.getMonth() - (trailingMonths - 1), 1),
    toDate: new Date(now.getFullYear(), now.getMonth() + 1, 7),
  };
};

const isTrailingMonthsOption = (value: number): value is TrailingMonthsOption =>
  value === 1 || value === 2 || value === 3;

export const resolveModelViewDates = (view: {
  useTrailingDates?: boolean;
  trailingMonths?: TrailingMonthsOption;
  fromDate?: Date | null;
  toDate?: Date | null;
}): { fromDate: Date | null; toDate: Date | null } => {
  if (view.useTrailingDates) {
    return getTrailingDateRange(view.trailingMonths ?? DEFAULT_TRAILING_MONTHS);
  }

  return {
    fromDate: view.fromDate ?? null,
    toDate: view.toDate ?? null,
  };
};

export const parseTrailingMonthsFilter = (value: string | number): TrailingMonthsOption | null => {
  const months = typeof value === 'number' ? value : Number(value);
  return isTrailingMonthsOption(months) ? months : null;
};
